import {
    CModal,
    CModalHeader,
    CModalTitle,
    CModalBody,
    CTable,
    CTableRow,
    CTableHeaderCell,
    CTableBody,
    CTableDataCell,
} from '@coreui/react';
import { Language } from '../../language/English';

interface UtmParams {
    [key: string]: string | number | null;
}

interface UtmParametersModalProps {
    visible: boolean;
    onClose: () => void;
    utmParams: UtmParams;
}

const UtmParametersModal: React.FC<UtmParametersModalProps> = ({
    visible,
    onClose,
    utmParams,
}) => {
    return (
        <CModal visible={visible} onClose={onClose} alignment="center">
            <CModalHeader className="d-flex justify-content-between align-items-center">
                <CModalTitle>{Language.UTM_PARAMETERS}</CModalTitle>
            </CModalHeader>

            <CModalBody>
                <CTable small striped hover responsive className="mb-0">
                    <thead>
                        <CTableRow>
                            <CTableHeaderCell scope="col">
                                {Language.PARAMETER}
                            </CTableHeaderCell>
                            <CTableHeaderCell scope="col">
                                {Language.VALUE}
                            </CTableHeaderCell>
                        </CTableRow>
                    </thead>

                    <CTableBody>
                        {Object.entries(utmParams).map(([key, value]) => (
                            <CTableRow key={key}>
                                <CTableHeaderCell
                                    scope="row"
                                    className="text-nowrap text-muted small"
                                >
                                    {key}
                                </CTableHeaderCell>
                                <CTableDataCell className="small">
                                    {String(value)}
                                </CTableDataCell>
                            </CTableRow>
                        ))}
                    </CTableBody>
                </CTable>
            </CModalBody>
        </CModal>
    );
};

export default UtmParametersModal;
